export default {
  message: {
    Tour: {
      continue: "Weiter",
      back: "Zurück",
      finish: "Fertigstellen"
    },
    Login: {
      title: "Elternanmeldung",
      sign_in: "Anmelden",
      login_fail:
        "Authentifizierung fehlgeschlagen. Bitte versuchen Sie es erneut oder wenden Sie sich an die Schule.",
      forgot_password: "Passwort vergessen",
      create_account: "Konto erstellen",
      password: "Passwort",
      confirm_password: "Passwort bestätigen",
      password_reminder: "Passwort-Erinnerung",
      enter_email: "Geben Sie Ihre E-Mail-Adresse ein",
      validation_error: "Validierungsfehler",
      password_reminder_error_no_user_register:
        "Benutzername nicht gefunden. Bitte erneut versuchen oder neues Konto erstellen.",
      password_reminder_error_no_user: "Benutzername nicht gefunden.",
      password_reminder_sent: "Eine E-Mail mit weiteren Anweisungen wurde an {email} gesendet.",
      password_reminder_sent_message:
        "Die E-Mail kann ein paar Minuten dauern. Überprüfen Sie auch Ihren Spam-Ordner.",
      password_trouble_email: "Wenn Sie weiterhin Probleme haben, kontaktieren Sie {email}.",
      password_trouble_school: "Bei Problemen wenden Sie sich bitte an Ihre Schule.",
      return_to_sign_in: "Zurück zur Anmeldung",
      create_my_account: "Mein Konto erstellen",
      or_sign_in_with: "ODER ANMELDEN MIT",
      password_reset: "Bitte wählen Sie ein neues Passwort.",
      password_reset_warning:
        "Wenn Sie die Änderung nicht angefordert haben, wenden Sie sich bitte umgehend an den Schuladministrator.",
      password_update: "Neues Passwort wählen",
      password_update_confirm: "Neues Passwort bestätigen",
      password_update_success: "Ihr neues Passwort wurde gespeichert."
    },
    AccountSettings: {
      title: "Kontoeinstellungen",
      first_name: "Vorname",
      last_name: "Nachname",
      email: "E-Mail",
      username: "Benutzername",
      password: "Passwort",
      students: "Schüler",
      teachers: "Lehrer",
      external_id: "Externe ID",
      phone: "Telefonnummer",
      phone_required: "Telefonnummer ist erforderlich",
      edit: "Bearbeiten",
      remove: "Entfernen",
      add: "Hinzufügen",
      remove_message: "Möchten Sie diesen Schüler wirklich entfernen?",
      yes: "Ja",
      no: "Nein",
      add_student: "Schüler hinzufügen",
      close: "Schließen",
      save: "Änderungen speichern",
      cancel: "Abbrechen",
      student_alert_message: "Sie müssen mindestens einen Schüler eingeben.",
      logout: "Abmelden"
    },
    TrialStatus: {
      title: "Update Trial Status",
      schoolLabel: "School",
      currentStatus: "Current Status",
      newStatus: "New Status",
      updatedSuccess: "Trial status updated successfully",
      updateError: "Failed to update trial status",
      statuses: {
        requested: "Requested",
        pending: "Pending",
        fullfilled: "Fulfilled",
        expired: "Expired",
        cancelled: "Cancelled",
        rejected: "Rejected",
        converted: "Converted"
      }
    },
    Navbar: {
      my_meetings: "Meine Termine",
      language: "Deutsch",
      help: "Hilfe",
      account_settings: "Kontoeinstellungen",
      user_management: "User Management",
      logout: "Abmelden"
    },
    SubNavbar: {
      meeting: "Besprechung",
      event: "Veranstaltung",
      print: "Drucken",
      email: "E-Mail",
      export: "Exportieren"
    },
    ConferenceCard: {
      add_edit_meetings: "Termine hinzufügen/bearbeiten",
      opening: "Geöffnet",
      closed: "Geschlossen"
    },
    Agenda: {
      full_agenda: "Gesamter Zeitplan",
      empty_state_title: "Keine Konferenzen gefunden.",
      empty_state_message: "Bei Fragen wenden Sie sich bitte an Ihre Schule.",
      confirmation_modal_title: "Zeitplan Bestätigt",
      confirmation_modal_message:
        "Ihr Zeitplan wurde erfolgreich bestätigt und eine E-Mail wurde an Sie gesendet.",
      complete_button: "Fertig!"
    },
    AgendaCard: {
      room: "Raum nicht verfügbar",
      room_with_value: "Raum: {room}",
      virtual_meeting: "Virtuelles Meeting",
      all_conferences: "Alle Konferenzen",
      conference: "Konferenz",
      student: "Schüler",
      meeting_with: "Termin mit",
      date_time: "Datum/Uhrzeit",
      meeting_type: "Terminart",
      location: "Ort",
      comment: "Kommentar",
      action: "Aktion",
      delete: "Löschen",
      add_comment: "Kommentar hinzufügen",
      join: "Meeting beitreten",
      choose_meeting_type: "Terminart wählen",
      in_person: "Vor Ort",
      phone: "Telefon",
      callback: "Rückruf",
      virtual: "Virtuell",
      hybrid: "Hybrid",
      unavailable: "Nicht verfügbar",
      tooltip_translator:
        "Der Dolmetscherdienst ist nicht garantiert, aber die Schule wird sich bemühen, ihn bereitzustellen.",
      translator_requested: "{language}-Dolmetscher angefordert",
      clear_translator: "Dolmetscheranforderung löschen",
      need_translator: "Benötigen Sie einen Dolmetscher?",
      choose_language: "Sprache wählen"
    },
    ScheduleMatrix: {
      no_teachers_title: "Keine Lehrer oder Teams ausgewählt.",
      no_teachers_message: "Bitte wählen Sie einen Lehrer aus, um seine Terminzeiten zu sehen.",
      choose_teachers_button: "Verfügbare Lehrer oder Teams anzeigen",
      choose_student: "Für welchen Schüler?",
      cancel: "Abbrechen"
    },
    Matrix: {
      teachers: "Lehrer",
      agenda: "Überprüfen und fortfahren"
    },
    DrawerTeachers: {
      teachers: "Lehrer",
      name: "Name",
      description: "Beschreibung",
      student: "Schüler",
      teacher_team: "Lehrer/Team",
      show_more: "Weitere Lehrer anzeigen",
      show_all: "Alle Lehrer der Schule anzeigen",
      selected: "({count}) ausgewählt",
      closeDrawer: "Zur Zeitplanung fortfahren",
      search: "Lehrer oder Team suchen",
      not_available: "Dieser Lehrer hat am {date} keine verfügbaren Terminzeiten."
    },
    DrawerAgenda: {
      no_meetings_title: "Keine Termine geplant.",
      no_meetings_message:
        "Sobald Sie einen Lehrer und eine Uhrzeit wählen, wird er hier angezeigt.",
      new_meeting_label: "Neu",
      cancel_button: "Abbrechen",
      student_label: "Schüler",
      meeting_type_location: "Art/Ort des Treffens",
      comment_label: "Kommentar",
      save_comment_button: "Kommentar speichern",
      confirm_label: "Bitte bestätigen:",
      confirm_cancel_button: "Ja, Termin mit ",
      do_not_cancel_button: "Nicht abbrechen",
      confirm_agenda_button: "Diesen Zeitplan bestätigen",
      confirm_agenda_message_line1: "Sie können jederzeit zurückkehren und Änderungen vornehmen.",
      confirm_agenda_message_line2: "Ihr aktueller Zeitplan wird per E-Mail gesendet."
    },
    EmailConsent: {
      message:
        "Um Ihre Privatsphäre zu schützen, benötigen wir Ihre Zustimmung zum Versenden von E-Mails.",
      consent: "Zustimmen"
    },
    UserManagement: {
      pageTitle: "User Management",
      pageSubtitle:
        "Add and manage school and district staff accounts. Staff sign in with school or district login using this site's account.",
      addUser: "Add user",
      editUser: "Edit user",
      loading: "Loading users…",
      emptyTitle: "No staff users yet",
      emptyMessage: "Use Add user to create a school or district staff account.",
      tableUsername: "Username",
      tableEmail: "Email",
      tableRole: "Role",
      tableActions: "Actions",
      typeSchool: "School",
      typeDistrict: "District",
      roleTeam: "Team",
      roleSchool: "School Admin",
      roleReporter: "School Reporter",
      roleDistrict: "District Admin",
      roleNoIntegration: "School Admin without Integration",
      roleNotSet: "Role not set",
      roleUnknown: "Role ({id})",
      formUsername: "Username",
      formEmail: "Email",
      formPassword: "Password",
      formNewPassword: "New password (optional)",
      formRole: "Role",
      loginHint:
        "Staff sign in with the school portal. District staff may use the district portal subdomain when applicable.",
      save: "Save",
      cancel: "Cancel",
      edit: "Edit",
      delete: "Delete",
      confirmDeleteTitle: "Remove this user?",
      confirmDeleteBody:
        "This will remove the staff account from your school. This action cannot be undone.",
      validationRequired: "Please fill in all required fields.",
      createdSuccess: "User created.",
      updatedSuccess: "User updated.",
      deletedSuccess: "User removed.",
      genericError: "Something went wrong. Please try again.",
      changeRoleTitle: "Change role",
      roleUpdatedSuccess: "Role updated.",
      deleteUserAria: "Remove user",
      formSchool: "School",
      validationSchoolRequired: "Please select a school.",
      schoolListEmpty: "No schools are available in this district."
    },
    StudentsDirectory: {
      saveLinkHousehold: "Save link household",
      saveLinkHouseholdNothing: "No changes to save.",
      saveLinkHouseholdSuccess: "Link household updated for {count} students.",
      saveLinkHouseholdError: "Could not update link household.",
      saveLinkHouseholdPartial: "Updated {saved} students; {failed} could not be saved."
    }
  }
};
